/**
 * External dependencies
 */
import { tns } from 'tiny-slider/src/tiny-slider.js';

const wrappers = document.querySelectorAll('.economy-carousel');

if (0 !== wrappers.length) {
	wrappers.forEach(function (wrapper, key) {
		wrapper.setAttribute('id', 'economy-carousel-' + key);
		tns({
			autoplay: true,
			autoplayButtonOutput: false,
			autoHeight: true,
			mouseDrag: true,
			loop: true,
			items: 1,
			container: wrapper.querySelector('.economy-carousel__container'),
			speed: 400,
			swipeAngle: false,
			prevButton:
				'#economy-carousel-' +
				key +
				' .economy-carousel__controls-prev',
			nextButton:
				'#economy-carousel-' +
				key +
				' .economy-carousel__controls-next',
			navContainer:
				'#economy-carousel-' + key + ' .economy-carousel__nav',
		});
	});
}
